<template>
  <header class="topbar">
    <div class="nav-offset" aria-hidden="true"></div>
    <div class="right">
      <h1 class="page-title">{{ $route.meta.title || '' }}</h1>
      <div class="actions">
        <div v-if="canPreviewClient" class="client-view-control">
          <span class="client-view-label">Visualizar como</span>
          <el-select
            :model-value="clientViewState.selectedClient"
            class="client-view-select"
            placeholder="Administrador"
            @change="changeClientView"
          >
            <el-option label="Administrador" value="" />
            <el-option
              v-for="client in clientViewState.authorizedClients"
              :key="client"
              :label="client"
              :value="client"
            />
          </el-select>
        </div>
        <el-dropdown class="user-dd" trigger="click" placement="bottom-end" popper-class="user-popper">
          <span class="action">
            <el-icon><User /></el-icon><span>{{ emailDomain || 'Usuário' }}</span>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item disabled v-if="emailDomain" class="domain-info">
                <span>{{ emailDomain }}</span>
              </el-dropdown-item>
              <el-dropdown-item @click="logout">
                <el-icon><SwitchButton /></el-icon><span>Logout</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { User, SwitchButton } from "@element-plus/icons-vue";
import userManager from "../../services/oidcUserManager";
import {
  clearBusinessClientsCache,
  loadBusinessClients,
} from "../../services/businessClients";
import { getDisplayEmailDomain } from "../../utils/emailDomain";
import {
  clientViewState,
  setClientView,
} from "../../utils/clientView";

export default {
  name: "AppHeader",
  components: { User, SwitchButton },
  data() {
    return {
      emailDomain: null,
      clientViewState,
    };
  },
  computed: {
    canPreviewClient() {
      return this.clientViewState.authorizedClients.length > 1;
    },
  },
  async mounted() {
    this.emailDomain = await getDisplayEmailDomain();
    try {
      await loadBusinessClients();
    } catch (error) {
      console.error("Erro ao carregar empresas para visualização:", error);
    }
  },
  methods: {
    changeClientView(client) {
      setClientView(client);
    },
    async logout() {
      clearBusinessClientsCache();
      try {
        await userManager.removeUser();
      } catch (error) {
        console.error("Erro ao remover a sessão local:", error);
      } finally {
        window.location.replace("/login");
      }
    },
  },
};
</script>


<style scoped>
@import "@/assets/css/fonts.css";

.topbar{
  display:flex;
  align-items:center;
  height:64px;
  background:#f5f7f8;
  border-bottom:1px solid #d2e0fb;
  font-family: "Globo-Regular";
}
.nav-offset{
  height:64px;
  flex-shrink:0;
}
.right{
  display:grid;
  grid-template-columns:auto 1fr;
  align-items:center;
  column-gap:16px;
  padding:0 16px;
  width:100%;
  box-sizing:border-box;
}
.page-title{
  margin:0;
  font-family:"Globo-Bold","Globo-Regular";
  font-size:20px;
  color:#3a6d8c;
  white-space:nowrap;
}
.actions{
  display:flex;
  justify-self:end;
  align-items:center;
  gap:28px;
  white-space:nowrap;
}
.client-view-control {
  display: flex;
  align-items: center;
  gap: 8px;
}
.client-view-label {
  color: #3a6d8c;
  font-size: 13px;
}
.client-view-select {
  width: 180px;
}
.action{
  font-family: "Globo-Regular";
  display:inline-flex;
  align-items:center;
  gap:8px;
  font-size:15px;
  color:#3a6d8c;
}
:deep(.el-button.is-text){ padding:0; color:#3a6d8c; }
:deep(.el-button.is-text:hover){ color:#2b5e7a; }
.actions :deep(.el-icon){ color:#3a6d8c; }
.user-popper .el-dropdown-menu{
  min-width:240px;
  padding:8px 0;
  border-radius:10px;
  box-shadow:0 6px 24px rgba(0,0,0,.08);
  font-family:"Globo-Regular";
}
.user-popper .el-dropdown-menu__item{
  display:flex;
  align-items:center;
  gap:10px;
  padding:12px 16px;
  font-size:15px;
  color:#3a6d8c;
  white-space:nowrap;
}
.user-popper .el-dropdown-menu__item .el-icon{ color:#3a6d8c; }
.domain-info {
  font-size: 12px !important;
  color: #999 !important;
  padding: 8px 16px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  cursor: default !important;
}
.domain-info:hover {
  background-color: transparent !important;
}
</style>
